<template>
    <card>
       <template slot="header">
          <h3 class="card-title">System Users</h3>
       </template>
        <breadcrumb-menu></breadcrumb-menu>
       <!-- SEARCH BY USERNAME -->
       <p><i class="fa fa-search"></i> Search Employee</p>
       <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
       <div class="table-responsive ">
          <table class="table table-striped table-hover " v-loading="loading">
             <thead>
                <tr>
                   <th width="20" >#</th>
                   <th width="90">User Name</th>
                   <th width="200">Account Type</th>
                   <th width="400">Email</th>
                   <th width="120">Password Reset</th>
                   <th width="100">Create At</th>
                   <th width="30">Update</th>
                </tr>
             </thead>
             <tbody>
                <tr v-for="(item,i) in computedLeave">
                   <template v-if="item === 'no data found'">
                      <td colspan="100%">
                         <h4>  <i class="fa fa-database"></i> Empty Records ...</h4>
                      </td>
                   </template>
                   <template v-else>
                      <td>{{i+1}}</td>
                      <td><i class="fa fa-user-o"></i> {{item.name}}</td>
                      <td>
                         <span v-if="item.role_id == '1'"><span class="badge badge-pill badge-primary m-size">Office Staff</span></span>
                         <span v-else-if="item.role_id == '2'"><span class="badge badge-pill badge-warning m-size">Supervisor</span></span>
                         <span v-else-if="item.role_id == '3'"><span class="badge badge-pill badge-danger m-size">Assistant Manager</span></span>
                         <span v-else-if="item.role_id == '4'"><span class="badge badge-pill badge-secondary m-size">Business Developement Manager</span></span>
                         <span v-else-if="item.role_id == '5'"><span class="badge badge-pill badge-danger m-size">HR Department</span></span>
                         <span v-else-if="item.role_id == '6'"><span class="badge badge-pill badge-success m-size">Chief Operating Officer</span></span>
                         <span v-else-if="item.role_id == '7'"><span class="badge badge-pill badge-success m-size">Chief Executive Officer</span></span>
                         <span v-else-if="item.role_id == '8'"><span class="badge badge-pill badge-success m-size">Chief Financial Officer</span></span>
                         <span v-else-if="item.role_id == '9'"><span class="badge badge-pill badge-success m-size">Chief Operation Director</span></span>
                         <span v-else-if="item.role_id == '10'"><span class="badge badge-pill badge-success m-size">Chief Administrative Officer</span></span>
                         <span v-else-if="item.role_id == '11'"><span class="badge badge-pill badge-danger m-size">Operation Manager</span></span>
                      </td>
                      <td v-text="item.email"></td>
                      <td>
                            <i class="fa fa-key"></i> <a href="#" @click="get_selected_id(item)"  v-b-modal.reset-password-user><u>Reset Password</u></a>
                      </td>
                      <td> <i class="fa fa-calendar-o"></i> {{getDate(item.created_at)}}</td>
                      <td>  <button class="btn btn-primary btn-xs btn-circle"   @click="get_selected_id(item)"  v-b-modal.update-user-account    v-b-tooltip.hover title="Update User"><i class="fa fa-pencil"></i></button></td>
                   </template>
                </tr>
             </tbody>
          </table>
       </div>
       <!-- MODAL FOR UPDATE RECORD  -->
       <b-modal id="update-user-account" ref="hide-user-modal"  size="l" hide-footer>
          <h3>Username & Email</h3>
          <div class="form-group">
             <label>Username:</label>
             <input type="text" class="form-control" v-model="selected_item.name">
             <label>Email:</label>
             <input type="text" class="form-control" v-model="selected_item.email">
          </div>
          <div class="form-group">
             <button class="btn btn-info float-right" @click="update_user"><i class="fa fa-save"></i>&nbsp;Save Changes</button>
          </div>
          <br/> <br/> 
       </b-modal>
       <!-- MODAL FOR RESET PASSWORD  -->
       <b-modal id="reset-password-user" ref="hide-reset-form-modal"  size="l" hide-footer>
          <h3>Reset Password</h3>
          <div class="form-group">  
             <input type="password" class="form-control" v-model="new_password">
          </div>
          <div class="form-group">
             <b-alert show variant="danger">
                <i class="fa fa-warning"></i> <i>Resseting password for: <b>{{selected_item.full_name | capitalize}} ?</b></i>
             </b-alert>
          </div>
          <div class="form-group">
             <button class="btn btn-info float-right" @click="reset_password"><i class="fa fa-repeat"></i>&nbsp;Reset password</button>
          </div>
          <br/> <br/> 
       </b-modal>
    </card>
 </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'  
import breadcrumbMenu from './base-breadcrumb-menu'
export default {
   components: {
       Card,
       breadcrumbMenu
   },
   data(){
        return{
            items:[],
            loading: true,
            selected_item:'',
            new_password:'Blueprint@111',
            search:'',
        }
    },

    mounted: function() {
      this.get_users()
   },

    methods:{
          get_users(){
            axios.get('api/users')
                .then(response => {   this.items = response.data; this.loading = false; })  
                .catch(error => {  console.log(error) });
          },

          get_selected_id(item) {
               this.selected_item = item;
          },

          update_user(){
                axios.post('api/users/update/' + this.selected_item.id,{
                        'role_id':this.selected_item.role_id,
                        'name':this.selected_item.name,
                        'email':this.selected_item.email,
                })
                .then(resp => {
                        this.$refs['hide-user-modal'].hide();
                        this.get_users();
                        alert('success');
                })      
                .catch(error => {
                        console.log(error);
                });
          }, 

          reset_password(e){
            e.preventDefault();
            this.$swal({
                title: 'Are you sure?',
                text: 'Do you want to reset password.',
                type: 'warning',
                showCancelButton: true,
                showCloseButton: false,
                })
                .then((isConfirm) => {
                if (isConfirm === true) {
                    axios.post('api/resetpassword/update/' + this.selected_item.id,{
                                'new_password':this.new_password,
                        })
                        .then(resp => {
                             if(resp.data.response =='success'){
                                 this.$refs['hide-reset-form-modal'].hide();
                                 this.get_users()
                                 this.$swal({
                                    type: 'success',
                                    title: 'Success',
                                    text: resp.data.message,
                                    showConfirmButton: false,
                                    timer: 2000
                                 })
                             }else if(resp.data.response =='error'){
                                  this.get_users()
                                  this.$swal({
                                    type: 'error',
                                    title: 'Oops',
                                    text: resp.data.message,
                                    timer: 2000
                                 })
                             }
                               
                        })      
                        .catch(error => {
                                console.log(error);
                        });
                   }
                });
          }    
   },
   computed:{

     computedLeave(){
        // SEARCH BY EMPLOYEE FULLNAME
        let filtered = this.items;
        if (filtered.length > 0) { 
           if (this.search) {
              filtered = filtered.filter(
                item => item.full_name.toLowerCase().indexOf(this.search) > -1
              );
              return filtered;
            }
        }
        return filtered;
    }    
   },
   filters: {
             capitalize: function (value) {    
                if (!value) return ''
                  value = value.toString()
                  //return value.charAt(0).toUpperCase() + value.slice(1); -> capitalize first 
                  return  value.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}); // -> capitalize each first words
               }
            }
}
</script>
<style>
     .bg-breadcrum{
            background:#fff;
         }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-users/todo-users.vue